export default __webpack_public_path__ + "static/media/plus.0b2eb7bb.svg";